import "./SignatureScreenComponent.scss";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import BrandingComponent from "../../shared/components/layout/branding/brandingComponent";
import {Add} from "@mui/icons-material";
import DialogComponent from "../../shared/components/dialog/dialogComponent";
import SignatureV2Component from "../../shared/components/signature-v2/SignatureV2Component";
import {IRootReducerState} from "../../store/reducers";
import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CommonService} from "../../shared/services";
import {IAPIResponseType} from "../../shared/models/api.model";
import {setUserSignature} from "../../store/actions/account.action";
import {ImageConfig} from "../../constants";
import {useLocation, useNavigate} from "react-router-dom";

const SignatureScreenComponent = () => {
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const signature = useSelector(
        (state: IRootReducerState) => state.account.userSignature
    );

    const [isSignatureModelOpen, setIsSignatureModelOpen] =
        useState<boolean>(false);
    const [appliedSignature, setAppliedSignature] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const handleRedirect = useCallback(() => {
        const query = CommonService.parseQueryString(location.search);
        let returnUrl = CommonService._routeConfig.Dashboard();
        if (Object.keys(query).includes("returnUrl")) {
            returnUrl = query.returnUrl;
        }
        navigate(returnUrl);
    }, [navigate, location]);
    const storeSignature = useCallback(
        (value: {
            type: string;
            signature: string | null;
            font?: string;
            color?: string;
        }) => {
            setAppliedSignature(value.signature);
            setIsSignatureModelOpen(false);
        },
        []
    );

    const handleProceedSignature = useCallback(() => {
        setIsLoading(true);
        CommonService._account
            .AddSignature(currentUser?.id,{signature: appliedSignature})
            .then((response: IAPIResponseType<any>) => {
                console.log(response);
                dispatch(setUserSignature(response.data));
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [appliedSignature, currentUser?.id, dispatch]);

    useEffect(() => {
        if (signature?.signature) {
            handleRedirect();
        }
    }, [handleRedirect, signature]);

    return (
        <div className="signature-screen-component">
            <div className="signature-header">
                <BrandingComponent sideMenuView={"default"}/>
            </div>
            <div className="signature-card">
                <div className="signature-card-header">
                    <div className="signature-card-header-title">
                        Welcome to{" "}
                        <span className="text-primary">
              {CommonService.getCurrentInstanceName(currentUser)}'s
            </span>{" "}
                        AI LabX!
                    </div>
                    <div className="signature-card-header-description">
                        To comply with medical standards and ensure operational accuracy,
                        your signature is required to complete the onboarding process. This
                        is mandatory for maintaining compliance with medical regulations.
                    </div>
                </div>
                <div className="signature-card-body">
                    <div className="signature-card-body-header">Signature:</div>
                    {!appliedSignature ? (
                        <ButtonComponent
                            startIcon={<Add/>}
                            variant="outlined"
                            handleClick={() => setIsSignatureModelOpen(true)}
                        >
                            Add Signature
                        </ButtonComponent>
                    ) : (
                        <div className="signature-box-container">
                            <div
                                className="signature-box"
                                style={{backgroundImage: `url(${appliedSignature})`}}
                            />
                            <ButtonComponent
                                className="clear-signature pdd-right-0"
                                variant="text"
                                handleClick={() => setAppliedSignature(null)}
                            >
                                Remove
                            </ButtonComponent>
                        </div>
                    )}
                </div>
                <div className="signature-card-footer">
                    <ButtonComponent
                        variant="contained"
                        isLoading={isLoading}
                        disabled={!appliedSignature}
                        handleClick={handleProceedSignature}
                        endIcon={<ImageConfig.ArrowCircleRightOutlinedIcon/>}
                    >
                        Submit and Proceed
                    </ButtonComponent>
                </div>
            </div>

            <DialogComponent
                isShowCancel={true}
                fullWidth={true}
                onClose={() => setIsSignatureModelOpen(false)}
                title={"Add Signature:"}
                // open={(signature?.isSignatureRequired && !signature?.signature) ?? false}
                open={isSignatureModelOpen}
            >
                {isSignatureModelOpen && (
                    <SignatureV2Component onSave={storeSignature}/>
                )}
            </DialogComponent>
        </div>
    );
};

export default SignatureScreenComponent;
